import TestCardDialog from './TestCardDialog';

export default TestCardDialog;